var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24589 11.6154V4.14179H0.761824V11.6154H3.24589ZM2.00418 3.12079C2.87041 3.12079 3.4096 2.54691 3.4096 1.82974C3.39347 1.09641 2.87045 0.538452 2.02061 0.538452C1.17092 0.538452 0.615265 1.09642 0.615265 1.82974C0.615265 2.54694 1.15432 3.12079 1.98796 3.12079H2.0041H2.00418ZM4.62081 11.6154H7.10487V7.44176C7.10487 7.2184 7.12101 6.99526 7.18661 6.83559C7.36619 6.38931 7.77492 5.92709 8.46112 5.92709C9.36 5.92709 9.7196 6.61244 9.7196 7.61712V11.6153H12.2035V7.33004C12.2035 5.03445 10.978 3.96634 9.34364 3.96634C8.00359 3.96634 7.41522 4.71538 7.08835 5.22555H7.10493V4.14164H4.62086C4.65346 4.84292 4.62086 11.6152 4.62086 11.6152L4.62081 11.6154Z",
    fill: "#25201D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/li.2e4f71e9a93ca559d3d72eabb64a4f8e.svg";
export { ForwardRef as ReactComponent };